import { render, staticRenderFns } from "./ministerUnassigned.vue?vue&type=template&id=7739365a&scoped=true&"
import script from "./ministerUnassigned.vue?vue&type=script&lang=js&"
export * from "./ministerUnassigned.vue?vue&type=script&lang=js&"
import style0 from "./ministerUnassigned.vue?vue&type=style&index=0&id=7739365a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7739365a",
  null
  
)

export default component.exports